/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.4.2.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import * as tslib_1 from "tslib";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
export var API_BASE_URL_TAGGING = new InjectionToken('API_BASE_URL_TAGGING');
var TaggingClient = /** @class */ (function () {
    function TaggingClient(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * Get contexts
     * @return Returns a list of contexts
     */
    TaggingClient.prototype.getContexts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/contexts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetContexts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetContexts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetContexts = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(ContextDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get expectations
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns a list of expectations
     */
    TaggingClient.prototype.getExpectations = function (contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/expectations?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(ExpectationTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get work value expectations
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns a list of work value expectations
     */
    TaggingClient.prototype.getWorkValueExpectations = function (contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/expectations/workvalues?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWorkValueExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWorkValueExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetWorkValueExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(ExpectationTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get team role expectations
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns a list of team role expectations
     */
    TaggingClient.prototype.getTeamRoleExpectations = function (contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/expectations/teamroles?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTeamRoleExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTeamRoleExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTeamRoleExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(ExpectationTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get expectation types
     * @return Returns a list of expectation types
     */
    TaggingClient.prototype.getExpectationTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/expectationtypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExpectationTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExpectationTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetExpectationTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(ExpectationTypeTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan expectations
     * @return Returns a list of expectation scores ordered by rank (highest score first)
     */
    TaggingClient.prototype.getJobScanExpectations = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/expectations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScanExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScanExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetJobScanExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(JobScanExpectationDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan expectation report
     * @param id The job scan id
     * @param contextId (optional) Specifies the context of the expectations. If not specified, it takes the default context
     * @return Returns an expectation report
     */
    TaggingClient.prototype.getJobScanExpectationReport = function (id, contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/expectations/report?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScanExpectationReport(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScanExpectationReport(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetJobScanExpectationReport = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = JobScanExpectationReportDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan expectation report url
     * @param id The job scan id
     * @param language (optional) Two-letter code for the language, eg 'en'
     * @return Returns an expectation report url
     */
    TaggingClient.prototype.getJobScanExpectationReportUrl = function (id, language) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/expectations/reporturl?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScanExpectationReportUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScanExpectationReportUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetJobScanExpectationReportUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan answers
     * @param id The job scan id
     * @return Success
     */
    TaggingClient.prototype.getJobScanAnswers = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScanAnswers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScanAnswers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetJobScanAnswers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(AnswerDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * add job scan answers
     * @param id The job scan id in the url path
     * @param body (optional) A list of answers with question id and answer option id as json in the body
     * @return Success
     */
    TaggingClient.prototype.putJobScanAnswers = function (id, body) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPutJobScanAnswers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPutJobScanAnswers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processPutJobScanAnswers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan answer percentage
     * @param id The job scan id
     * @return Success
     */
    TaggingClient.prototype.getJobScanAnswerPercentage = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/answers/percentage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScanAnswerPercentage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScanAnswerPercentage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetJobScanAnswerPercentage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Calculate expectations for a job scan
     * @param id The job scan id in the url path
     * @param body (optional) The language in two letter ISO code. For example, for English this is "en".
                The default value is "nl" (Dutch).
     * @return Accepted
     */
    TaggingClient.prototype.calculateJobScanExpectations = function (id, body) {
        var _this = this;
        var url_ = this.baseUrl + "/jobscans/{id}/expectations/calculate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCalculateJobScanExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCalculateJobScanExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processCalculateJobScanExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get job scan questions with answer options
     * @param contextId (optional) Specifies the context of the questions and answers. If not specified, it takes the default context
     * @return Returns a list of job scan questions and their answer options
     */
    TaggingClient.prototype.getJobScanQuestions = function (contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/questions/jobscan?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJobScanQuestions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJobScanQuestions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetJobScanQuestions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(QuestionWithAnswerOptionsDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan questions with answer options
     * @param contextId (optional) Specifies the context of the questions and answers. If not specified, it takes the default context
     * @return Returns a list of talent scan questions and their answer options
     */
    TaggingClient.prototype.getTalentScanQuestions = function (contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/questions/talentscan?";
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScanQuestions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScanQuestions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTalentScanQuestions = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(QuestionWithAnswerOptionsDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get question types
     * @return Returns a list of question types
     */
    TaggingClient.prototype.getQuestionTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/questiontypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetQuestionTypes = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(QuestionTypeTranslatedDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Calculate expectations for a talent scan
     * @param id The talent scan id in the url path
     * @param body (optional) The language in two letter ISO code. For example, for English this is "en".
                The default value is "nl" (Dutch).
     * @return Accepted
     */
    TaggingClient.prototype.calculateTalentScanExpectations = function (id, body) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/expectations/calculate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCalculateTalentScanExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCalculateTalentScanExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processCalculateTalentScanExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan answers
     * @param id The talent scan id
     * @return Success
     */
    TaggingClient.prototype.getTalentScanAnswers = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScanAnswers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScanAnswers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTalentScanAnswers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(AnswerDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * add talent scan answers
     * @param id The talent scan id
     * @param body (optional) A list of answers with question id and answer option id as json in the body
     * @return Success
     */
    TaggingClient.prototype.putTalentScanAnswers = function (id, body) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/answers";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPutTalentScanAnswers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPutTalentScanAnswers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processPutTalentScanAnswers = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan answer percentage
     * @param id The talent scan
     * @return Success
     */
    TaggingClient.prototype.getTalentScanAnswerPercentage = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/answers/percentage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScanAnswerPercentage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScanAnswerPercentage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTalentScanAnswerPercentage = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan expectation report
     * @param id The talent scan id
     * @param contextId (optional) Specifies the context of the questions and answers. If not specified, it takes the default context
     * @return Returns a expectation report
     */
    TaggingClient.prototype.getTalentScanExpectationReport = function (id, contextId) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/expectations/report?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contextId === null)
            throw new Error("The parameter 'contextId' cannot be null.");
        else if (contextId !== undefined)
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScanExpectationReport(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScanExpectationReport(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTalentScanExpectationReport = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TalentScanExpectationReportDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan expectation report url
     * @param id The talent scan id
     * @param language (optional) Two-letter code for the language, eg 'en'
     * @return Returns an expectation report url
     */
    TaggingClient.prototype.getTalentScanExpectationReportUrl = function (id, language) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/expectations/reporturl?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScanExpectationReportUrl(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScanExpectationReportUrl(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTalentScanExpectationReportUrl = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * Get talent scan expectations
     * @return Returns a list of expectation scores ordered by rank (highest score first)
     */
    TaggingClient.prototype.getTalentScanExpectations = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/talentscans/{id}/expectations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTalentScanExpectations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTalentScanExpectations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TaggingClient.prototype.processGetTalentScanExpectations = function (response) {
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            for (var _i = 0, _a = response.headers.keys(); _i < _a.length; _i++) {
                var key = _a[_i];
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result400 = null;
                var resultData400 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result400 = ApiErrorResponse.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        }
        else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(TalentScanExpectationDto.fromJS(item));
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TaggingClient;
}());
export { TaggingClient };
var ApiError = /** @class */ (function () {
    function ApiError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiError.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    };
    ApiError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiError();
        result.init(data);
        return result;
    };
    ApiError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    };
    return ApiError;
}());
export { ApiError };
var ValidationError = /** @class */ (function () {
    function ValidationError(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ValidationError.prototype.init = function (_data) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.errorCode = _data["errorCode"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationError.fromJS(item));
                }
            }
        }
    };
    ValidationError.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ValidationError();
        result.init(data);
        return result;
    };
    ValidationError.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["errorCode"] = this.errorCode;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        return data;
    };
    return ValidationError;
}());
export { ValidationError };
var ApiErrorResponse = /** @class */ (function () {
    function ApiErrorResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApiErrorResponse.prototype.init = function (_data) {
        if (_data) {
            this.apiError = _data["apiError"] ? ApiError.fromJS(_data["apiError"]) : undefined;
            this.correlationId = _data["correlationId"];
            this.errorMessage = _data["errorMessage"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (var _i = 0, _a = _data["validationErrors"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.validationErrors.push(ValidationError.fromJS(item));
                }
            }
            this.detail = _data["detail"];
        }
    };
    ApiErrorResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApiErrorResponse();
        result.init(data);
        return result;
    };
    ApiErrorResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["apiError"] = this.apiError ? this.apiError.toJSON() : undefined;
        data["correlationId"] = this.correlationId;
        data["errorMessage"] = this.errorMessage;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (var _i = 0, _a = this.validationErrors; _i < _a.length; _i++) {
                var item = _a[_i];
                data["validationErrors"].push(item.toJSON());
            }
        }
        data["detail"] = this.detail;
        return data;
    };
    return ApiErrorResponse;
}());
export { ApiErrorResponse };
var ContextDto = /** @class */ (function () {
    function ContextDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContextDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    ContextDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContextDto();
        result.init(data);
        return result;
    };
    ContextDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    return ContextDto;
}());
export { ContextDto };
var Translation = /** @class */ (function () {
    function Translation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Translation.prototype.init = function (_data) {
        if (_data) {
            this.en = _data["en"];
            this.nl = _data["nl"];
            this.fr = _data["fr"];
        }
    };
    Translation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Translation();
        result.init(data);
        return result;
    };
    Translation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["nl"] = this.nl;
        data["fr"] = this.fr;
        return data;
    };
    return Translation;
}());
export { Translation };
var ExpectationTranslatedDto = /** @class */ (function () {
    function ExpectationTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpectationTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
            this.jobScanDescription = _data["jobScanDescription"] ? Translation.fromJS(_data["jobScanDescription"]) : undefined;
            this.talentScanDescription = _data["talentScanDescription"] ? Translation.fromJS(_data["talentScanDescription"]) : undefined;
            this.expectationTypeId = _data["expectationTypeId"];
            this.iconUrl = _data["iconUrl"];
        }
    };
    ExpectationTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpectationTranslatedDto();
        result.init(data);
        return result;
    };
    ExpectationTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["jobScanDescription"] = this.jobScanDescription ? this.jobScanDescription.toJSON() : undefined;
        data["talentScanDescription"] = this.talentScanDescription ? this.talentScanDescription.toJSON() : undefined;
        data["expectationTypeId"] = this.expectationTypeId;
        data["iconUrl"] = this.iconUrl;
        return data;
    };
    return ExpectationTranslatedDto;
}());
export { ExpectationTranslatedDto };
var ExpectationTypeTranslatedDto = /** @class */ (function () {
    function ExpectationTypeTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpectationTypeTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    ExpectationTypeTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpectationTypeTranslatedDto();
        result.init(data);
        return result;
    };
    ExpectationTypeTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return ExpectationTypeTranslatedDto;
}());
export { ExpectationTypeTranslatedDto };
var JobScanExpectationDto = /** @class */ (function () {
    function JobScanExpectationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    JobScanExpectationDto.prototype.init = function (_data) {
        if (_data) {
            this.jobScanId = _data["jobScanId"];
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    };
    JobScanExpectationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new JobScanExpectationDto();
        result.init(data);
        return result;
    };
    JobScanExpectationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["jobScanId"] = this.jobScanId;
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data;
    };
    return JobScanExpectationDto;
}());
export { JobScanExpectationDto };
var ClusterTranslatedDto = /** @class */ (function () {
    function ClusterTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClusterTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    ClusterTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClusterTranslatedDto();
        result.init(data);
        return result;
    };
    ClusterTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return ClusterTranslatedDto;
}());
export { ClusterTranslatedDto };
var JobScanExpectationReportDto = /** @class */ (function () {
    function JobScanExpectationReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    JobScanExpectationReportDto.prototype.init = function (_data) {
        if (_data) {
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.title = _data["title"];
            this.employer = _data["employer"];
            if (Array.isArray(_data["teamRoles"])) {
                this.teamRoles = [];
                for (var _i = 0, _a = _data["teamRoles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.teamRoles.push(ExpectationTranslatedDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["workValues"])) {
                this.workValues = [];
                for (var _b = 0, _c = _data["workValues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.workValues.push(ExpectationTranslatedDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["clusters"])) {
                this.clusters = [];
                for (var _d = 0, _e = _data["clusters"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.clusters.push(ClusterTranslatedDto.fromJS(item));
                }
            }
        }
    };
    JobScanExpectationReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new JobScanExpectationReportDto();
        result.init(data);
        return result;
    };
    JobScanExpectationReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["title"] = this.title;
        data["employer"] = this.employer;
        if (Array.isArray(this.teamRoles)) {
            data["teamRoles"] = [];
            for (var _i = 0, _a = this.teamRoles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["teamRoles"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.workValues)) {
            data["workValues"] = [];
            for (var _b = 0, _c = this.workValues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["workValues"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.clusters)) {
            data["clusters"] = [];
            for (var _d = 0, _e = this.clusters; _d < _e.length; _d++) {
                var item = _e[_d];
                data["clusters"].push(item.toJSON());
            }
        }
        return data;
    };
    return JobScanExpectationReportDto;
}());
export { JobScanExpectationReportDto };
var AnswerDto = /** @class */ (function () {
    function AnswerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AnswerDto.prototype.init = function (_data) {
        if (_data) {
            this.answerOptionId = _data["answerOptionId"];
            this.questionId = _data["questionId"];
        }
    };
    AnswerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AnswerDto();
        result.init(data);
        return result;
    };
    AnswerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["answerOptionId"] = this.answerOptionId;
        data["questionId"] = this.questionId;
        return data;
    };
    return AnswerDto;
}());
export { AnswerDto };
var AnswerOptionTranslatedDto = /** @class */ (function () {
    function AnswerOptionTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AnswerOptionTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.priority = _data["priority"];
            this.description = _data["description"] ? Translation.fromJS(_data["description"]) : undefined;
        }
    };
    AnswerOptionTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AnswerOptionTranslatedDto();
        result.init(data);
        return result;
    };
    AnswerOptionTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priority"] = this.priority;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        return data;
    };
    return AnswerOptionTranslatedDto;
}());
export { AnswerOptionTranslatedDto };
var QuestionWithAnswerOptionsDto = /** @class */ (function () {
    function QuestionWithAnswerOptionsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuestionWithAnswerOptionsDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.expectationTypeId = _data["expectationTypeId"];
            this.title = _data["title"] ? Translation.fromJS(_data["title"]) : undefined;
            this.description = _data["description"] ? Translation.fromJS(_data["description"]) : undefined;
            this.descriptionListItemsTitle = _data["descriptionListItemsTitle"] ? Translation.fromJS(_data["descriptionListItemsTitle"]) : undefined;
            if (Array.isArray(_data["descriptionListItems"])) {
                this.descriptionListItems = [];
                for (var _i = 0, _a = _data["descriptionListItems"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.descriptionListItems.push(Translation.fromJS(item));
                }
            }
            this.priority = _data["priority"];
            if (Array.isArray(_data["answerOptions"])) {
                this.answerOptions = [];
                for (var _b = 0, _c = _data["answerOptions"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.answerOptions.push(AnswerOptionTranslatedDto.fromJS(item));
                }
            }
        }
    };
    QuestionWithAnswerOptionsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuestionWithAnswerOptionsDto();
        result.init(data);
        return result;
    };
    QuestionWithAnswerOptionsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["expectationTypeId"] = this.expectationTypeId;
        data["title"] = this.title ? this.title.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["descriptionListItemsTitle"] = this.descriptionListItemsTitle ? this.descriptionListItemsTitle.toJSON() : undefined;
        if (Array.isArray(this.descriptionListItems)) {
            data["descriptionListItems"] = [];
            for (var _i = 0, _a = this.descriptionListItems; _i < _a.length; _i++) {
                var item = _a[_i];
                data["descriptionListItems"].push(item.toJSON());
            }
        }
        data["priority"] = this.priority;
        if (Array.isArray(this.answerOptions)) {
            data["answerOptions"] = [];
            for (var _b = 0, _c = this.answerOptions; _b < _c.length; _b++) {
                var item = _c[_b];
                data["answerOptions"].push(item.toJSON());
            }
        }
        return data;
    };
    return QuestionWithAnswerOptionsDto;
}());
export { QuestionWithAnswerOptionsDto };
var QuestionTypeTranslatedDto = /** @class */ (function () {
    function QuestionTypeTranslatedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuestionTypeTranslatedDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? Translation.fromJS(_data["name"]) : undefined;
        }
    };
    QuestionTypeTranslatedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuestionTypeTranslatedDto();
        result.init(data);
        return result;
    };
    QuestionTypeTranslatedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        return data;
    };
    return QuestionTypeTranslatedDto;
}());
export { QuestionTypeTranslatedDto };
var TalentScanExpectationReportDto = /** @class */ (function () {
    function TalentScanExpectationReportDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TalentScanExpectationReportDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["teamRoles"])) {
                this.teamRoles = [];
                for (var _i = 0, _a = _data["teamRoles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.teamRoles.push(ExpectationTranslatedDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["workValues"])) {
                this.workValues = [];
                for (var _b = 0, _c = _data["workValues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.workValues.push(ExpectationTranslatedDto.fromJS(item));
                }
            }
            if (Array.isArray(_data["clusters"])) {
                this.clusters = [];
                for (var _d = 0, _e = _data["clusters"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.clusters.push(ClusterTranslatedDto.fromJS(item));
                }
            }
        }
    };
    TalentScanExpectationReportDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TalentScanExpectationReportDto();
        result.init(data);
        return result;
    };
    TalentScanExpectationReportDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.teamRoles)) {
            data["teamRoles"] = [];
            for (var _i = 0, _a = this.teamRoles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["teamRoles"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.workValues)) {
            data["workValues"] = [];
            for (var _b = 0, _c = this.workValues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["workValues"].push(item.toJSON());
            }
        }
        if (Array.isArray(this.clusters)) {
            data["clusters"] = [];
            for (var _d = 0, _e = this.clusters; _d < _e.length; _d++) {
                var item = _e[_d];
                data["clusters"].push(item.toJSON());
            }
        }
        return data;
    };
    return TalentScanExpectationReportDto;
}());
export { TalentScanExpectationReportDto };
var TalentScanExpectationDto = /** @class */ (function () {
    function TalentScanExpectationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TalentScanExpectationDto.prototype.init = function (_data) {
        if (_data) {
            this.talentScanId = _data["talentScanId"];
            this.expectationId = _data["expectationId"];
            this.score = _data["score"];
            this.outDated = _data["outDated"];
            this.rank = _data["rank"];
            this.reportRank = _data["reportRank"];
        }
    };
    TalentScanExpectationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TalentScanExpectationDto();
        result.init(data);
        return result;
    };
    TalentScanExpectationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["talentScanId"] = this.talentScanId;
        data["expectationId"] = this.expectationId;
        data["score"] = this.score;
        data["outDated"] = this.outDated;
        data["rank"] = this.rank;
        data["reportRank"] = this.reportRank;
        return data;
    };
    return TalentScanExpectationDto;
}());
export { TalentScanExpectationDto };
var SwaggerException = /** @class */ (function (_super) {
    tslib_1.__extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
